__turbopack_context__.v({
  "error": "TasksFeedGrid-module-scss-module__jH2uqW__error",
  "errorText": "TasksFeedGrid-module-scss-module__jH2uqW__errorText",
  "grid": "TasksFeedGrid-module-scss-module__jH2uqW__grid",
  "loadMore": "TasksFeedGrid-module-scss-module__jH2uqW__loadMore",
  "root": "TasksFeedGrid-module-scss-module__jH2uqW__root",
  "skeletonBody": "TasksFeedGrid-module-scss-module__jH2uqW__skeletonBody",
  "skeletonCard": "TasksFeedGrid-module-scss-module__jH2uqW__skeletonCard",
  "skeletonCover": "TasksFeedGrid-module-scss-module__jH2uqW__skeletonCover",
  "skeletonLine": "TasksFeedGrid-module-scss-module__jH2uqW__skeletonLine",
  "skeletonLineShort": "TasksFeedGrid-module-scss-module__jH2uqW__skeletonLineShort",
  "srOnly": "TasksFeedGrid-module-scss-module__jH2uqW__srOnly",
  "tasksListPulse": "TasksFeedGrid-module-scss-module__jH2uqW__tasksListPulse",
});
